var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentMulti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 14.1567H8.33331V15.6733H14.3333V14.1567Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33331 9.60667V11.1233H18.6666V9.60667H8.33331Z",
    fill: "#474747"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33331 5.05667V6.57333H18.6666V5.05667H8.33331Z",
    fill: "#474747"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8533 0H6.14665C5.28331 0 4.58331 0.726667 4.58331 1.62V2.76667H3.14665C2.28331 2.76667 1.58331 3.49333 1.58331 4.39V22.38C1.58331 23.2767 2.28331 24 3.14665 24H17.8533C18.7166 24 19.4166 23.2733 19.4166 22.38V20.9H20.8533C21.7166 20.9 22.4166 20.1767 22.4166 19.2833V1.62C22.4166 0.726667 21.7166 0 20.8533 0ZM17.9166 22.38C17.9166 22.4467 17.8733 22.48 17.8533 22.48H3.14665C3.12331 22.48 3.08331 22.4467 3.08331 22.38V4.38667C3.08331 4.32 3.12665 4.28333 3.14665 4.28333H4.58331V19.28C4.58331 20.1733 5.28331 20.8967 6.14665 20.8967H17.9166V22.38ZM20.9166 19.2833C20.9166 19.35 20.8733 19.3833 20.8533 19.3833H6.14665C6.12331 19.3833 6.08331 19.35 6.08331 19.2833V1.62C6.08331 1.55333 6.12665 1.52 6.14665 1.52H20.8533C20.8766 1.52 20.9166 1.55333 20.9166 1.62V19.2833Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentMulti);
export default __webpack_public_path__ + "static/media/document_multi.71e5c3e86451bb3540abf520ed758060.svg";
export { ForwardRef as ReactComponent };